import axios from "axios";

export async function createTargetGroup(levelNumber, data) {
    try {
        const response = await axios.post(`/targetGroups/create/${levelNumber}`, data);
        return response.data.group;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка создания группы";
        throw new Error(text);
    }
}
